import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import PicList from '../../../../components/picList';
import NewsList from '../../../../components/newsList';

class FoBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { foTopic, foTitle, foList0, foList1 },
        } = this.props;

        return (
            <div id="foNewsList" className={styles.fo_box}>
                <Chip id="50081" type="struct" title="佛教栏标题" groupName="佛教栏" content={foTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75110"
                    type="recommend"
                    title="佛教栏头条"
                    groupName="佛教栏"
                    content={foTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75111"
                    type="recommend"
                    title="佛教栏新闻列表1"
                    groupName="佛教栏"
                    content={foList0}
                    translate="handleVideoContentData"
                    translateOptions={{ index: 0 }}>
                    <PicList />
                </Chip>
                <Chip
                    id="75112"
                    type="recommend"
                    title="佛教栏新闻列表2"
                    groupName="佛教栏"
                    content={foList1}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(FoBox);
